var paywall = require("./lib/paywall");
setTimeout(() => paywall(11971045), 5000);

require("component-responsive-frame/child");
require("waypoints/lib/noframework.waypoints.min");
require("./brightcove");
require("./audio");

// lazy load images and loopers
var lazyImages = [].slice.call(document.querySelectorAll(".lazy"));

if ("IntersectionObserver" in window) {
  let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        let lazyImage = entry.target;
        lazyImage.src = lazyImage.dataset.src;
        lazyImage.classList.remove("lazy");
        lazyImageObserver.unobserve(lazyImage);
      }
    });
  });

  lazyImages.forEach(function(lazyImage) {
    lazyImageObserver.observe(lazyImage);
  });
} else {
	document.addEventListener("DOMContentLoaded", function() {
	  let active = false;

	  const lazyLoad = function() {
	    if (active === false) {
	      active = true;

	      setTimeout(function() {
	        lazyImages.forEach(function(lazyImage) {
	          if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
	            lazyImage.src = lazyImage.dataset.src;
	            lazyImage.srcset = lazyImage.dataset.srcset;
	            lazyImage.classList.remove("lazy");

	            lazyImages = lazyImages.filter(function(image) {
	              return image !== lazyImage;
	            });

	            if (lazyImages.length === 0) {
	              document.removeEventListener("scroll", lazyLoad);
	              window.removeEventListener("resize", lazyLoad);
	              window.removeEventListener("orientationchange", lazyLoad);
	            }
	          }
	        });

	        active = false;
	      }, 200);
	    }
	  };

	  document.addEventListener("scroll", lazyLoad);
	  window.addEventListener("resize", lazyLoad);
	  window.addEventListener("orientationchange", lazyLoad);
	});
}

var hero = document.querySelector(".hero"),
	hero_video = document.querySelector(".hero__video");

// change hero source video
function changeHeroVideo() {

	if (window.innerWidth < window.innerHeight * 1.3) {
		hero.classList.remove("horizontal");
		hero.classList.add("vertical");

		hero_video.src = "./assets/00_Intro_vertical.mp4";
	} else {
		hero.classList.remove("vertical");
		hero.classList.add("horizontal");

		hero_video.src = "./assets/00_Intro.mp4";
	}
}

// once user has scrolled to beginning of story, fade out hero looper
var beginning = document.querySelector("#beginning"),
	hero_looper = hero.querySelector(".hero__figure");

function animateHero() {
	new Waypoint({
	  element: beginning,
	  offset: "95%",
	  handler: function(direction) {
	  	if (direction === "down") {
	  		hero_looper.classList.remove("shown");
	  		hero_looper.classList.add("hidden");
	  	} else {
	  		hero_looper.classList.remove("hidden");
	  		hero_looper.classList.add("shown");
	  	}
	  }
	});
}

// background color change
var body = document.querySelector("body");
var colorChanges = [].slice.call(document.querySelectorAll(".color-change"));
colorChanges.forEach(function(c) {
	new Waypoint({
	  element: c,
	  offset: "50%",
	  handler: function(direction) {
	  	body.classList.remove("orlando");
	  	body.classList.remove("jesus");
	  	body.classList.remove("gustavo");
	  	body.classList.remove("josue");
	  	body.classList.remove("maggie");
	  	body.classList.add(c.dataset.color);
	  }
	});
});

// fade out border map
var border_map = document.querySelector(".border-map");

new Waypoint({
  element: border_map,
  offset: "30%",
  handler: function(direction) {
  	if (direction === "down") {
  		border_map.classList.remove("unfaded");
		border_map.classList.add("faded");
  	} else {
  		border_map.classList.remove("faded");
		border_map.classList.add("unfaded");
  	}
  }
});

changeHeroVideo();
animateHero();

window.addEventListener("resize", changeHeroVideo);
window.addEventListener("resize", animateHero);

// expand images when clicked
var expandable_images = document.querySelectorAll(".expandable"),
	viewer = document.querySelector("#expanded-media");

Array.from(expandable_images).forEach(expandable_image => {
	expandable_image.addEventListener("click", function() {
		var media_type = expandable_image.tagName,
				media_element = media_type === "IMG" ? viewer.querySelector("img") : viewer.querySelector("video"),
				media_file = expandable_image.src;

		var media_elements = document.querySelectorAll(".expanded-media__media");
		media_elements.forEach(function(el) {
			if (el.tagName === media_type) {
				el.classList.remove("hidden");
				el.classList.add("shown");
			} else {
				el.classList.remove("shown");
				el.classList.add("hidden");
			}
		});

		viewer.classList.remove("hidden");
		viewer.classList.add("expanded");
		
		media_element.src = media_file;
	});
});

viewer.addEventListener("click", function() {
	viewer.classList.remove("expanded");
	viewer.classList.add("hidden");
});